import axiosInstance from "../instance/axiosInstance";

class AdminDirectorApi {
  static async adminDirector() {
    try {
      const response = await axiosInstance.get("/organization/admin/director");
      if (response) {
        return response.data;
      }
    } catch (error) {
      return error;
    }
  }

  static async adminDirectorBranchesHQ() {
    try {
      const response = await axiosInstance.get("/getBranchesHQ");
      if (response) {
        return response.data;
      }
    } catch (error) {
      return error;
    }
  }
  static async adminDirectorDepartments(branchId) {
    try {
      const response = await axiosInstance.get(`/getDepartments/${branchId}`);
      if (response) {
        return response.data;
      }
    } catch (error) {
      return error;
    }
  }

  static async updateAdminDirector(formData) {
    try {
      const response = await axiosInstance.post(
        "/organization/admin/director/save",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      return response.data;
    } catch (error) {
      return error;
    }
  }

  static async getAdminsListWithoutPg() {
    try {
      const response = await axiosInstance.get("admin/list-without-pg");
      if (response) {
        return response.data;
      }
    } catch (error) {
      return error;
    }
  }
}

export default AdminDirectorApi;
